import { render, staticRenderFns } from "./IncomeSummary.vue?vue&type=template&id=ceb12fe4&scoped=true"
import script from "./IncomeSummary.vue?vue&type=script&lang=js"
export * from "./IncomeSummary.vue?vue&type=script&lang=js"
import style0 from "./IncomeSummary.vue?vue&type=style&index=0&id=ceb12fe4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb12fe4",
  null
  
)

export default component.exports